// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qF-z","hovered":"rF-z","hoverImage":"sF-z","mainImage":"tF-z","imageNoBackground":"uF-z","fullSizeImage":"vF-z"};